// components/SearchWidget.jsx
import React, { useState, useEffect,useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { Search, X, TrendingUp, Clock, ArrowRight, Sparkles,Eye } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import axios from 'axios';
import configs from '../config/config';
const SearchWidget = ({ config = {}, isOpen, onClose,allCategories,popularProducts,allCategorieX=[],loading,search_Query }) => {
  const navigate = useNavigate();
  const location = useLocation();
const[topMargin,setTopMargin]=useState('-60px');
const[mobileTopMargin,setMobileTopMargin]=useState('-10px');
  // This gives you only "home"
  const currentPath = location.pathname.substring(1);
 useEffect(() => {
    if (currentPath === "home" || currentPath === "MainPage_s") {
      setTopMargin('-18px');
      setMobileTopMargin('30px');
    } else {
      setTopMargin('137px');
      setMobileTopMargin('140px');        // reset for other pages
    }
  }, [currentPath]); 
  // Defensive config handling: force object, handle nested or array safely
  const actualConfig = 
    config?.searchSettings && typeof config.searchSettings === 'object' && !Array.isArray(config.searchSettings)
      ? config.searchSettings
      : (typeof config === 'object' && !Array.isArray(config) ? config : {});

  const defaultConfig = {
    activeDesign: 'design2', // 'design1', 'design2', 'design3'
    placeholder: 'Search products, brands, categories...',
    trending: ['New arrivals', 'Sale items', 'Best sellers', 'Gift ideas', 'Sustainable fashion'],
    categories: ['Women', 'Men', 'Accessories', 'Footwear', 'Sale', 'New Arrivals'],
    devMode: false,
    customStyles: {},
  };

 const token = localStorage.getItem('token');


  const finalConfig = { ...defaultConfig, ...actualConfig };
  const {
    activeDesign,
    placeholder,
    trending,
    categories,
    devMode,
    customStyles
  } = finalConfig;

  const [searchQuery, setSearchQuery] = useState('');
  const [recentSearches, setRecentSearches] = useState([]);
 let featuredBg = localStorage.getItem('featuredBg') || configs.BASE_COLOR;
  const activeBg = localStorage.getItem('activeBg') || configs.BASE_COLOR;
if(featuredBg=='bg-gray-400'){
  featuredBg=configs.BASE_COLOR;
}
  // Load recent searches from localStorage
  useEffect(() => {
    const saved = localStorage.getItem('recentSearches');
    if (saved) setRecentSearches(JSON.parse(saved));
  }, []);

  // Save recent searches
 const handleSearch = (query) => {
  /**  setTimeout(function(){
      search(query);

    },3000);**/
    

   
  };

  const handleNavigate = (slug) => {
    window.location.assign(`/Shop/all/${slug.toLowerCase()}`);
 
  };
const[selectedVariants,setselectedVariants]=useState([]);

  const handleAddToCart = useCallback(async (id) => {
   

    //setSaving(true);
    try {
      const payload = {
        product_id: id,
        quantity:1,
        session: localStorage.getItem('session_id') || `guest-${Date.now()}`,
        selected_variants: JSON.stringify(selectedVariants),
      };

      const xsrfToken = document.cookie
        .split('; ')
        .find(row => row.startsWith('XSRF-TOKEN='))
        ?.split('=')[1];

      await axios.post(`${configs.API_URL}/api/addToCart2/${id}`, payload, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-XSRF-TOKEN": decodeURIComponent(xsrfToken || ''),
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });

//      toast.success('Added to cart!');
    } catch (err) {
     // toast.error('Failed to add to cart');
      console.error(err);
    } finally {
     // setSaving(false);
    }
  }, []);


// Format currency (KES)
  const formatCurrency = (amount) =>
    new Intl.NumberFormat('en-KE', {
      style: 'currency',
      currency: 'KES',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);

  // Sample popular products (replace with real API fetch later)
 

 /**const fetchAllProductsAndCategories = async () => {
    try {
      const [categoriesRes] = await Promise.all([
        axios.get(`${config.API_URL}/api/pullCategories`, {
          headers: { Authorization: `Bearer ${token}` },
        })
      ]);

      const categoriesArray =
        categoriesRes.data?.newCategories2 ||
        categoriesRes.data?.data ||
        [];
      setCategories(['All', ...categoriesArray]);
    } catch (err) {
      console.error("Failed to fetch categories:", err);
    }
  };

  useEffect(() => {
    fetchAllProductsAndCategories();
  }, [token]);
  const [loading, setLoading] = useState(false);
  **/
 
  /** const search = async (query) => {
    try {

    setLoading(true);

      await axios.get(configs.API_URL + "/sanctum/csrf-cookie", { withCredentials: true });

      const xsrfToken = document.cookie
        .split('; ')
        .find(row => row.startsWith('XSRF-TOKEN='))
        ?.split('=')[1];

      const endpoint ='/api/pull_products';

        

      const response = await axios.post(
        configs.API_URL + endpoint,
        {searchQuery:searchQuery,token:token},
        {
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "X-XSRF-TOKEN": decodeURIComponent(xsrfToken || ''),
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      );

      setLoading(false);
       setProducts(response.data.data || []);
       setCategories(response.data.suggestions || []);
         if (!query.trim()) return;
    const newSearches = [query.trim(), ...recentSearches.filter(s => s !== query.trim())].slice(0, 5);
    setRecentSearches(newSearches);
    localStorage.setItem('recentSearches', JSON.stringify(newSearches));
     
    } catch (error) {
      console.error("Save error:", error);
      //alert("Failed to save.");
    } finally {
      //setSaving(false);
    }
  };**/

  const filteredProducts = searchQuery
    ? popularProducts.filter(p =>
        p.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        p.category.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : popularProducts;

  if (!isOpen) return null;

  const containerStyles = {
    background: devMode && customStyles.background ? customStyles.background : undefined,
    color: devMode && customStyles.textColor ? customStyles.textColor : undefined,
  };

  // Design 1: Full Screen Overlay
  const Design1 = () => (
    <div className="fixed inset-0 bg-white z-50 overflow-y-auto" style={containerStyles}>
      {/* Header */}
      <div className="sticky top-0 bg-white border-b border-gray-200 z-10">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-4">
          <div className="flex items-center gap-3">
            <div className="flex-1 relative">
              <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleSearch(searchQuery)}
                onKeyUp={(e) =>  handleSearch(searchQuery)}
                placeholder={placeholder}
                className="w-full pl-12 pr-4 py-3.5 bg-gray-100 rounded-full text-base focus:outline-none focus:ring-2 focus:ring-gray-900"
                autoFocus
              />
              {searchQuery && (
                <button
                  onClick={() => setSearchQuery('')}
                  className="absolute right-4 top-1/2 -translate-y-1/2 w-6 h-6 bg-gray-200 rounded-full flex items-center justify-center hover:bg-gray-300"
                >
                  <X className="w-4 h-4 text-gray-600" />
                </button>
              )}
            </div>
            <button onClick={onClose} className="text-gray-600 hover:text-gray-900 font-medium px-4 py-2">
              Cancel
            </button>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8">
        {searchQuery.length === 0 ? (
          <div className="space-y-8">
            {recentSearches.length > 0 && (
              <div>
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wide">Recent Searches</h3>
                  <button onClick={() => { setRecentSearches([]); localStorage.removeItem('recentSearches'); }} className="text-sm text-gray-600 hover:text-gray-900">
                    Clear
                  </button>
                </div>
                <div className="space-y-2">
                  {recentSearches.map((s, i) => (
                    <button key={i} onClick={() => setSearchQuery(s)} className="w-full flex items-center gap-3 px-4 py-3 hover:bg-gray-50 rounded-lg text-left">
                      <Clock className="w-5 h-5 text-gray-400" />
                      <span className="text-gray-900">{s}</span>
                    </button>
                  ))}
                </div>
              </div>
            )}

            <div>
              <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wide mb-4">Trending Now</h3>
              <div className="flex flex-wrap gap-2">
                {trending.map((t, i) => (
                  <button key={i} onClick={() => setSearchQuery(t)} className="flex items-center gap-2 px-4 py-2.5 bg-gray-100 hover:bg-gray-200 rounded-full text-sm font-medium">
                    <TrendingUp className="w-4 h-4" /> {t}
                  </button>
                ))}
              </div>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wide mb-4">Popular Products</h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {popularProducts.map(p => (
                  <div key={p.id} className="group cursor-pointer">
                    <div className={`aspect-square rounded-lg ${p.image} mb-3`} />
                    <h4 className="text-sm font-medium text-gray-900 mb-1 line-clamp-2 group-hover:text-gray-600">{p.name}</h4>
                    <p className="text-sm font-semibold text-gray-900">${p.price}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : (
          <div className="space-y-6">
            <p className="text-sm text-gray-600 mb-4">{filteredProducts.length} results for "{searchQuery}"</p>
            {filteredProducts.length > 0 ? (
              <div className="space-y-3">
                {filteredProducts.map(p => (
                  <div key={p.id} className="flex items-center gap-4 p-3 hover:bg-gray-50 rounded-lg cursor-pointer">
                    <div className={`w-16 h-16 rounded-lg ${p.image}`} />
                    <div className="flex-1">
                      <h4 className="font-medium text-gray-900">{p.name}</h4>
                      <p className="text-sm text-gray-600">{p.category}</p>
                    </div>
                    <span className="font-semibold text-gray-900">${p.price}</span>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-12">
                <p className="text-gray-600">No results found</p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );

 const Design2 = () => (
  <>
    <style>{`
      @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&family=DM+Sans:wght@400;500;600&display=swap');
      
      
      
      .search-widget-container {
        animation: slideInFromTop 0.4s cubic-bezier(0.16, 1, 0.3, 1);
      }
      
      @keyframes slideInFromTop {
        from {
          opacity: 0;
          transform: translateY(-20px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
      
      .product-card {
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      }
      
      .product-card:hover {
        transform: translateY(-8px);
      }
      
      .product-card img {
        transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      }
      
      .product-card:hover img {
        transform: scale(1.05);
      }
      
      .category-button {
        transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
        position: relative;
        overflow: hidden;
      }
      
      .category-button::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 3px;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        transform: scaleY(0);
        transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      }
      
      .category-button:hover::before {
        transform: scaleY(1);
      }
      
      .category-button:hover {
        padding-left: 1rem;
        background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);
      }
      
      .close-search-btn {
        background: linear-gradient(135deg, rgba(102, 126, 234, 0.08) 0%, rgba(118, 75, 162, 0.08) 100%);
        border: 1.5px solid rgba(102, 126, 234, 0.2);
        backdrop-filter: blur(10px);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        position: relative;
        overflow: hidden;
      }
      
      .close-search-btn::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
        transition: left 0.5s ease;
      }
      
      .close-search-btn:hover::before {
        left: 100%;
      }
      
      .close-search-btn:hover {
        border-color: rgba(102, 126, 234, 0.4);
        background: linear-gradient(135deg, rgba(102, 126, 234, 0.12) 0%, rgba(118, 75, 162, 0.12) 100%);
        transform: translateY(-1px);
        box-shadow: 0 4px 16px rgba(102, 126, 234, 0.15);
      }
      
      .close-search-btn:active {
        transform: translateY(0);
        box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
      }
      
      .gradient-border {
        position: relative;
      }
      
      .gradient-border::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 2px;
        background: linear-gradient(90deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
        opacity: 0.4;
      }
      
      .loading-shimmer {
        background: linear-gradient(90deg, #e0f2fe 0%, #dbeafe 50%, #e0f2fe 100%);
        background-size: 200% 100%;
        animation: shimmer 2s ease-in-out infinite;
      }
      
      @keyframes shimmer {
        0% { background-position: 200% 0; }
        100% { background-position: -200% 0; }
      }
      
      .scroll-fade {
        mask-image: linear-gradient(to bottom, black calc(100% - 40px), transparent 100%);
        -webkit-mask-image: linear-gradient(to bottom, black calc(100% - 40px), transparent 100%);
      }
    `}</style>

    <div 
      className="search-widget-overlay"
      onClick={() => onClose()}
    />
    
   
<div 
  className="search-widget-container fixed left-0 right-0 bg-white shadow-xl z-[999999]"
  style={{
    ...containerStyles,                    // ← Spread containerStyles first
    marginTop: window.innerWidth < 768 
      ? mobileTopMargin 
      : topMargin
  }}
>
      <div className="max-w-9xl mx-auto">
        
       

        <div className="p-6 md:p-8 max-h-[70vh] overflow-y-auto scroll-fade">
          
           
          <div className="grid grid-cols-1 md:grid-cols-[8fr_2fr] gap-8 md:gap-12">
            <div>
              <div className="mb-6 flex items-center justify-between gap-3">
                <div className="h-8 w-1  rounded-full"></div>
               
                 <button
              onClick={() => onClose()}
              className="rounded px-4 py-1 bg-gray-900 relative h-11 rounded-xl flex items-center justify-center text-gray-700 font-medium text-sm tracking-wide transition-all"
              style={{marginTop: '-5px', marginBottom: '12px', float:'right'}}
            >
              <span className="flex items-center gap-1 px-4">
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="#ffffff" strokeWidth={2.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
                <span className="font-semibold text-white">Close </span>
              </span>
            </button>
              </div>

              {loading && (
            <div className="loading-shimmer py-6 px-6 rounded-2xl flex items-center justify-center mb-6 shadow-inner">
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 border-3 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
                <p className="text-lg font-medium text-blue-900">Searching products...</p>
              </div>
            </div>
          )}

              {filteredProducts.length > 0 ? (
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-5">
                  {filteredProducts.map((product) => (
                    <div 
                      onClick={() => {onClose(); navigate('/products/'+product.id);}} 
                      key={product.id} 
                      className="product-card cursor-pointer bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-2xl border border-gray-100"
                    >
                      <div className="overflow-hidden bg-gradient-to-br bg-white">
                        <img
                          src={product.image_url || 'https://placehold.co/400x500?text=No+Image'}
                          alt={product.name}
                          className="aspect-square"
                          loading="lazy"
                          onError={(e) => {
                            e.currentTarget.src = 'https://placehold.co/400x500?text=Image+Not+Found';
                          }}
                        />
                      </div>
                      
                      <div className="p-4 bg-white">
                        <h3 className="font-semibold text-sm text-gray-900 mb-1 line-clamp-2 leading-snug">
                          {product.name}
                        </h3>
                        <p className="text-xs text-gray-500 mb-2 font-medium tracking-wide uppercase">{product.category}</p>
                        <p className="font-bold text-lg text-transparent mb-0 bg-clip-text bg-gradient-to-r from-violet-600 to-purple-600" style={{color:featuredBg}}>
                          {formatCurrency(product.price)}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-16 px-4">
                  <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center">
                    <svg className="w-10 h-10 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                  </div>
                  <p className="text-gray-600 font-medium">No products found</p>
                  <p className="text-sm text-gray-400 mt-1">Try adjusting your search</p>
                </div>
              )}
            </div>

            <div className="border-l border-gray-200 pl-8">
              <div className="sticky top-0">
                <h3 className="text-xs font-bold text-gray-900 mb-5 tracking-wider uppercase flex items-center gap-2">
                  <svg className="w-4 h-4 text-violet-600" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z"/>
                    <path fillRule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z" clipRule="evenodd"/>
                  </svg>
                  Quick Suggestions
                </h3>
                <div className="space-y-1.5">
                  {allCategorieX.map((category) => (
                    <button
                      key={category}
                      onClick={() => {onClose(); handleNavigate(category);}}
                      className="category-button w-full text-left px-4 py-3 text-sm font-medium text-gray-700 hover:text-gray-900 rounded-lg transition-colors flex items-center justify-between group"
                    >
                      <span>{category}</span>
                      <ArrowRight className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-all transform group-hover:translate-x-1" />
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <center>
          <button  onClick={() => {onClose(); handleNavigate(search_Query);}} className="btn px-4 py-2 mt-3 text-white" style={{backgroundColor:featuredBg}} >View All results</button>
          </center>
          <br/><br/><br/><br/><br/><br/><br/><br/>
        </div>

      </div>
    </div>

  </>
);
  // Design 3: Compact Modal
  const Design3 = () => (
    <>
      <div 
        className="fixed inset-0 bg-black/50 z-50 flex items-start justify-center pt-20 p-4"
        onClick={() => onClose()}
      >
        <div 
          className="bg-white rounded-2xl shadow-2xl w-full max-w-7xl max-h-[100vh] flex flex-col"
          onClick={(e) => e.stopPropagation()}
          style={containerStyles}
        >
          {/* Search Input */}
          <div className="p-4 md:p-6 border-b border-gray-200">
            <div className="relative">
              <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleSearch(searchQuery)}
                 onKeyUp={(e) =>  handleSearch(searchQuery)}
                onKeyPress={(e) =>  handleSearch(searchQuery)}
                placeholder={placeholder}
                className="w-full pl-12 pr-12 py-3 border border-gray-300 rounded-lg text-base focus:outline-none focus:ring-2 focus:ring-gray-900 focus:border-transparent"
                autoFocus
              />
            {/*  {searchQuery ? (
                <button
                  onClick={() => setSearchQuery('')}
                  className="absolute right-3 top-1/2 -translate-y-1/2 w-7 h-7 bg-gray-200 rounded-full flex items-center justify-center hover:bg-gray-300"
                >
                  <X className="w-4 h-4 text-gray-600" />
                </button>
              ) : (
                <button
                  onClick={() => search()}
                  className="absolute bg-gray-900 py-3 px-4 rounded shadow text-white right-3 top-1/2 -translate-y-1/2 text-sm  hover:text-gray-700 font-medium"
                >
                  Search
                </button>
              )}*/}
            </div>
          </div>

          {/* Results */}
          <div className={`overflow-y-auto p-4 md:p-6`}>
            {searchQuery.length === 0 ? (
              <div className="space-y-6">
                
              </div>
            ) : (
              <div >
                {filteredProducts.length > 0 ? (
                  <div className={`grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-4 gap-3 `}>
                    {filteredProducts.map((product) => (
                       <div
  key={product.id}
  onClick={() => navigate(`/products/${product.id}`)}
  className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer flex flex-col"
>
  {/* IMAGE */}
  <div className="relative overflow-hidden flex-shrink-0">
    <img
      src={product.image_url || 'https://placehold.co/400x500?text=No+Image'}
      alt={product.name}
      className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500"
      loading="lazy"
      onError={(e) => {
        e.currentTarget.src =
          'https://placehold.co/400x500?text=Image+Not+Found';
      }}
    />

   

  

    {/* QUICK VIEW */}
    <div className="absolute bottom-4 right-4 opacity-0 group-hover:opacity-100 transition-all duration-300 translate-y-4 group-hover:translate-y-0">
      <button
        onClick={(e) => {
          e.stopPropagation();
          navigate(`/products/${product.id}`);
        }}
        className="bg-white p-2 rounded-full shadow-lg hover:bg-purple-600 hover:text-white transition-colors"
      >
        <Eye className="w-5 h-5" />
      </button>
    </div>
  </div>

  {/* CONTENT */}
  <div className="p-5 flex flex-col flex-grow">
   

    <h3 className="font-semibold text-gray-800 mb-2 line-clamp-2">
      {product.name}
    </h3>

    {/* PRICE */}
    <div className="flex items-center gap-2 mb-4">
      <span className="text-2xl font-bold text-purple-600">
        {formatCurrency(product.price)}
      </span>

     
    </div>

   
  </div>
</div>

                    ))}
                  </div>
                ) : (
                  <div className="text-center py-12">
                    <Search className="w-12 h-12 text-gray-300 mx-auto mb-3" />
                    <p className="text-gray-600 mb-2">No results found</p>
                    <p className="text-sm text-gray-500">Try a different search term</p>
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Footer 
          <div className="border-t border-gray-200 px-4 md:px-6 py-3 bg-gray-50 rounded-b-2xl">
            <div className="flex items-center justify-between text-xs text-gray-500">
              <span>Press ESC to close</span>
              <div className="flex gap-4">
                <span className="flex items-center gap-1">
                  <kbd className="px-2 py-1 bg-white border border-gray-300 rounded text-xs">↑</kbd>
                  <kbd className="px-2 py-1 bg-white border border-gray-300 rounded text-xs">↓</kbd>
                  to navigate
                </span>
                <span className="flex items-center gap-1">
                  <kbd className="px-2 py-1 bg-white border border-gray-300 rounded text-xs">↵</kbd>
                  to select
                </span>
              </div>
            </div>
          </div>
          */}
        </div>
      </div>
    </>
  );

  const renderDesign = () => {
    switch (activeDesign) {
      case 'design1':
        return <Design2 />;
      case 'design2':
        return <Design2 />;
      case 'design3':
        return <Design2 />;
      default:
        return <Design2 />;
    }
  };

  return renderDesign();
};

export default SearchWidget;